import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const ChargesListView: DynamicImport = () => import(/* webpackChunkName: "charges" */ '../views/ChargesListView.vue')
const ChargesFormView: DynamicImport = () => import(/* webpackChunkName: "charges" */ '../views/ChargesFormView/ChargesFormView.vue')
const ChargesItemView: DynamicImport = () => import(/* webpackChunkName: "charges" */ '../views/ChargesItemView.vue')
const PaymentsListView: DynamicImport = () => import(/* webpackChunkName: "charges" */ '../views/PaymentsListView.vue')
const DownloadPdfExport: DynamicImport = () => import(/* webpackChunkName: "charges" */ '../views/DownloadPdfExportView.vue')

const routes: (i18n: VueI18n) => Array<RouteConfig> = (i18n) => ([
  {
    path: '/charges/charges',
    name: 'charges-list',
    component: ChargesListView,
    meta: {
      title: i18n.t('charges.charges.listTitle'),
      appModule: 'charges',
      userPermission: ['charges', 1],
      buttons: [
        {
          label: i18n.t('charges.charges.addLabel'),
          to: { name: 'charges-form' },
          userPermission: ['charges', 2],
        }
      ]
    }
  },
  {
    path: '/charges/charges/form/:id?',
    name: 'charges-form',
    component: ChargesFormView,
    meta: {
      pageHeader: false,
      sidebarMode: 2,
      allowFullscreen: true,
      appModule: 'charges',
      userPermission: ['charges', 2],
    }
  },
  {
    path: '/charges/payments',
    name: 'charges-payments-list',
    component: PaymentsListView,
    meta: {
      title: i18n.t('charges.payments.listTitle'),
      appModule: 'charges',
      userPermission: ['charges', 1],
    }
  },
  {
    path: '/charges/charges/:id',
    name: 'charges-item',
    component: ChargesItemView,
    meta: {
      pageHeader: false,
      appModule: 'charges',
      userPermission: ['charges', 1],
    }
  },
  {
    path: '/charges/pdf-exports/:id/download',
    name: 'charges-pdf-export-download',
    component: DownloadPdfExport,
    meta: {
      pageHeader: false,
      title: 'Téléchargement'
    }
  }
])

export default routes
